import { useState } from 'react'
import { Globe, Coins, Calendar, Clock, Save, Check } from 'lucide-react'
import { COUNTRIES, ALL_CURRENCIES, getDefaultCurrency } from '../lib/localization'
import { DATE_FORMATS, TIMEZONES } from '../data/seed'
import { useAuth } from '../hooks/useAuth'
import { useToast } from '../lib/ToastContext'

export default function StaffPreferences({ prefs, onSave }) {
  const { user } = useAuth()
  const [country, setCountry] = useState(prefs?.country || 'Nigeria')
  const [currency, setCurrency] = useState(prefs?.currency || 'NGN')
  const [dateFormat, setDateFormat] = useState(prefs?.dateFormat || 'DD/MM/YYYY')
  const [timezone, setTimezone] = useState(prefs?.timezone || TIMEZONES[0])
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)
  const { toast } = useToast()

  const handleSave = () => {
    setLoading(true)
    setTimeout(() => {
      onSave?.({ country, currency, dateFormat, timezone })
      setSaved(true)
      toast('Preferences saved.', 'success')
      setTimeout(() => setSaved(false), 2200)
      setLoading(false)
    }, 500)
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-ink">My Preferences</h3>
          <p className="text-xs text-muted mt-0.5">Regional and display preferences</p>
        </div>
        {saved && (
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700">
            <Check size={14} /> Saved
          </span>
        )}
      </div>

      <div className="surface p-6 space-y-5">
        <div>
          <label className="label-above flex items-center gap-2"><Globe size={13} /> Country</label>
          <select value={country} onChange={(e) => setCountry(e.target.value)} className="input-flat">
            {COUNTRIES.map((c) => (<option key={c}>{c}</option>))}
          </select>
          <p className="text-[11px] text-muted mt-1.5">Determines compliance labels and legal templates.</p>
        </div>

        <div>
          <label className="label-above flex items-center gap-2"><Coins size={13} /> Currency</label>
          <select value={currency} onChange={(e) => setCurrency(e.target.value)} className="input-flat">
            {ALL_CURRENCIES.map((c) => (
              <option key={c.code} value={c.code}>{c.symbol} {c.code}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="label-above flex items-center gap-2"><Calendar size={13} /> Date Format</label>
          <div className="flex gap-3">
            {DATE_FORMATS.map((f) => (
              <button
                key={f}
                onClick={() => setDateFormat(f)}
                className={`px-4 py-2 text-xs font-semibold border transition-colors ${
                  dateFormat === f ? 'border-brand bg-brand-soft text-brand' : 'border-neutral-200 text-neutral-500 hover:text-ink'
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="label-above flex items-center gap-2"><Clock size={13} /> Timezone</label>
          <select value={timezone} onChange={(e) => setTimezone(e.target.value)} className="input-flat">
            {TIMEZONES.map((tz) => (<option key={tz}>{tz}</option>))}
          </select>
        </div>

        <button onClick={handleSave} disabled={loading} className="btn-primary flex items-center gap-2">
          <Save size={16} /> {loading ? 'Saving...' : 'Save Preferences'}
        </button>
      </div>
    </div>
  )
}